<template>
  <div class="container appointment-card mt-4">
    <div class="row">
      <div class="col-md-2">
        <div class="d-flex flex-column appointment-cell">
          <h6>Appointment Date:</h6>
          <h6 class="font-weight-bold">
            {{ appointment.startDateTime | formatDateOnly() }}
          </h6>
        </div>
      </div>

      <div class="col-md-2">
        <div class="d-flex flex-column appointment-cell">
          <h6>Appointment Time:</h6>
          <h6 class="font-weight-bold">
            {{ appointment.startDateTime | formatTimeOnly() }}
          </h6>
        </div>
      </div>

      <div class="col-md-2">
        <div class="d-flex flex-column appointment-cell">
          <h6>Appointment Length:</h6>
          <h6 class="font-weight-bold">
            {{ duration | humanMillis }}
          </h6>
        </div>
      </div>

      <div class="col-md-2">
        <div class="d-flex flex-column appointment-cell">
          <h6>Provider:</h6>
          <h6 class="font-weight-bold">{{ appointment.provider.fullName }}</h6>
        </div>
      </div>

      <div class="col-md-2">
        <div class="d-flex flex-column appointment-cell">
          <h6>Service:</h6>
          <h6 class="font-weight-bold">{{ appointment.service.name }}</h6>
        </div>
      </div>

      <div
        class="col-md-2 d-flex flex-row justify-content-center align-items-center"
      >
        <b-badge
          pill
          :class="
            `form-badge ${
              appointment.status === 'Pending' ? 'pending' : 'completed'
            }`
          "
        >
          {{ appointment.status }}
        </b-badge>
      </div>
    </div>
  </div>
</template>

<script>
import { lightenDarkenColor } from "../../helpers/general";
import { calculateDurationToMilliseconds } from "../../helpers/date";

export default {
  props: {
    appointment: Object
  },
  computed: {
    backgroundColor() {
      return lightenDarkenColor("#FO56b", 85);
    },
    duration() {
      return calculateDurationToMilliseconds(
        this.appointment.startDateTime,
        this.appointment.endDateTime
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.appointment-card {
  background-color: #f5f6f9;
  border-radius: 10px;
  padding: 15px 20px;
  margin-bottom: 1.5em;

  .appointment-cell {
    height: 100%;
    border-right: 2px #efeff2 solid;

    h6 {
      font-size: 0.8em;
      margin: 0;

      &:first-child {
        margin-bottom: 5px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .appointment-cell {
      border-right: none;
      margin-bottom: 1em;
    }
  }

  .form-badge {
    padding: 5px 10px;
    font-size: 0.8em;
    width: 100%;
    max-width: 100px;

    &.completed {
      background: #ccf9cf;
      color: #01be0e;
    }

    &.pending {
      background: #fff3ca;
      color: #ffc300;
    }
  }
}
</style>
